module.exports = __webpack_public_path__ + "static/media/axle-3-v.e2cfe68c.svg";